import config from '../config'
import http from '../http'

export default{

	getLoginInfo:async function(payload) {
		const res = await http({
			url: config.GET_SMSCODE_API,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},

	getLoginByPhoneCode:async function(payload) {
		const res = await http({
			url: config.GET_SMSCODE_CODE_API,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},

	getCodeByGroupId:async function(payload) {
		const res = await http({
			url: config.GROUP_CODE,
			method: 'get',
			data:{
				...payload
			}
		})
		return res.data
	},
	updataShipCost:async function(payload) {
		const res = await http({
			url: config.UPDATE_PURCHASE_SHIPCOST,
			method: 'post',
			data:{
				...payload
			}
		
			
		})
		return res.data
	},
	
	fixedUserSensitiveType:async function(payload) {
		const res = await http({
			url: config.FIEXED_USERINFO_SENITIVE,
			method: 'post',
			data:{
				...payload
			}
		
			
		})
		return res.data
	},
	massCreateOrder:async function(payload) {
		const res = await http({
			url: config.CREATE_DXS_ORDER_EXCEL,
			method: 'post',
			data:payload
		
			
		})
		return res.data
	},

	getPartnerId:async function(payload) {
		const res = await http({
			url: config.GET_PARTNER_ID,
			method: 'post',
			data:{
				...payload
			}
			
		})
		return res.data
	},
	
	unReturnOrderAll:async function(payload) {
		const res = await http({
			url: config.GIVE_UP_CLAIM,
			method: 'POST',
			data: payload
			
		})
		return res.data
	},
	
	alertReturnOrders:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_ALERT_RETURN,
			method: 'POST',
			data: {
				...payload
			}
		})
		return res.data
	},
	getOrderInfo:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_ADDRESS_CODE,
			method: 'POST',
			data: {
				...payload
			}
		})
		return res.data
	},
	proxyHttps:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_PROXYHTTPS,
			method: 'POST',
			data: {
				...payload
			}
		})
		return res.data
	},
	bindByItemKey:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_BIND_BYITEMKEY,
			method: 'POST',
			data: payload
		})
		return res.data
	},
	getUserInviteeByCode:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GETUSER_INFO_INVITATIONCODE,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	getDistributionStoreItems:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GETDISTRIBUTION_STOREITEMS,
			method: 'POST',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	queryLogisticsOrder:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_QUETY_LOGISTICS_ORDER,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},

	getUserInvitee:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_USER_INVITEE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	phoneRegister:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_PHONE_REGISTORE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	getPhoneCode:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_PHONE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getPhoneCodePassword:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_PHONE_PASSWORD,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	

	getUserInviteCode:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_USERINVITECODE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getUserInviteCodeByDistribution:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_JOIN_DISTRIBUTION,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getDistribution:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_DISTRIBUTION,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},

	queryRemindNum:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_QUERY_REMIND_NUM,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	queryRemindOrders:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_QUERY_RETURN_ORDERS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	getUserAttribute:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_USER_ATTRIBUTE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	updateUserAttribute:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_UPDATE_USER_ATTRIBUTE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	
	getOrderLogisticsInfo:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_ORDER_TIME,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},

	sellerRemind:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_SELLER_REMIND,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},




	queryPendingOrders:async function(payload) {
		const res = await http({
			url: config.QUER_PENDING_ORDERS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	getOrderInfoByScan:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GETORDER_BYSTYORE,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	getPrintHistory:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_PRINT_HISTORY,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},
	returnPurchaseOrder:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_RETURN_PURCHASEoRDER,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},
	getLogisticsRuleByStore:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_LOGISTICS_RULEBY_STORE,
			method: 'GET',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	createDxsLogisticsOrder:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_CREATE_DXSLOGISTICS_ORDER,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},




	delDxsStoreItem:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_DELETE_DXSORDER,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},



	//仓库转移卖家剩余仓库产品
	transferSellerStoreItem:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_TRANSFORM_STORE_ITEM_SELLER,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	//仓库查看卖家剩余仓库产品
	getSellerStoreItemData:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_SELLERITEM_STOREITEM_DATA,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	getStoreAllByType:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_STORE_ALLBYTYPE,
			method: 'get',
			data: {
				...payload
			}
			
		})
		return res.data
	},


	

	

	createDxsOrder:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_CREATE_DIANXIAOSHEN_ORDER,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	updateCheckTime:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_UPDATE_CHECKTIME,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	updateEmptyOrder:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_UPDATE_EMPTY_ORDER,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	apply:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_COMPLAIN_APPLY,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},
	getSellerComplainOrder:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_COMPLAIN_GET,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},
	storeDispose:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_STORE_DISPOST,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},
	

	getItemByItemKey:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_MASS_GETSTROEITEM_BYCUSCODE,
			method: 'post',
			data: payload
			
		})
		return res.data
	},

	getOrderBillUrl:async function(payload) {
		const res = await http({
			url: config.GET_ORDER_BILL_URL,
			method: 'post',
			data: payload
			
		})
		return res.data
	},

	getOrderPDF:async function(payload) {
		const res = await http({
			url: config.GET_ORDERS_PDF,
			method: 'post',
			data: payload
			
		})
		return res.data
	},
	
	sartReadyOrders:async function(payload) {
		const res = await http({
			url: config.SHOPORDER_START_READY_ORDERS,
			method: 'post',
			data: payload
			
		})
		return res.data
	},

	getNewOrders:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_NEW_ORDERS,
			method: 'post',
			data: payload
			
		})
		return res.data
	},

	setOrderFlag:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_SETORDER_FALG,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},
	
	cancelAuditedOrders:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_CANCEL_AUDITED_ORDERS,
			method: 'post',
			data: payload
			
		})
		return res.data
	},
	
	getLogistics:async function(payload) {
		const res = await http({
			url: config.PROCESSED_ORDERS_LOGISTICS,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},
	
	getPackagedOrdernum:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_QUERYPACKAGED_ORDERS_NUM,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	setPackaged:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_SET_PACKAGED,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},
	
	cancelAuditedOrders:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_CANCEL_AUDITED_ORDERS,
			method: 'post',
			data: payload
			
		})
		return res.data
	},
	
	getLogistics:async function(payload) {
		const res = await http({
			url: config.PROCESSED_ORDERS_LOGISTICS,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},
	
	getPackagedOrdernum:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_QUERYPACKAGED_ORDERS_NUM,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},
	
	updatePackagedTrackingWarningLabel:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_UPDATE_PACKAGED_TRACKING_WARNING_LABEL,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	setPackaged:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_SET_PACKAGED,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	addPrintNum:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_ADDPRINTNUM,
			method: 'post',
			data: payload
			
		})
		return res.data
	},

	updateOriginal:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_UPDATE_ORIGINAL,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	insertPrintHistory:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_INSERT_PRINT_HISTORY,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	updateCustomer:async function(payload) {
		const res = await http({
			url: config.UPDATA_CUSTOMER,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	
	updateMsgToStore:async function(payload) {
		const res = await http({
			url: config.UPDATA_MSG_TO_STORE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	sendMsgRemind:async function(payload) {
		const res = await http({
			url: config.SENDMSG_REMIND,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	addPrintNum:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_ADDPRINTNUM,
			method: 'post',
			data: payload
			
		})
		return res.data
	},

	updateOriginal:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_UPDATE_ORIGINAL,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	insertPrintHistory:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_INSERT_PRINT_HISTORY,
			method: 'post',
			data: {
				...payload
			}
			
		})
		return res.data
	},

	updateCustomer:async function(payload) {
		const res = await http({
			url: config.UPDATA_CUSTOMER,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	

	
}